import { createApp } from 'vue'
import App from './App.vue'
import store from '@/store'
// import VConsole from 'vconsole'

// new VConsole()
import directive from "@/utils/directive"
createApp(App).use(store).use(directive).mount('#app')


import VConsole from 'vconsole'
if (location.host == 'test.foshanplus.com') {
    new VConsole()
}